import { useState, useEffect, useRef } from 'react';
import { dispatch } from 'store';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';

// third-party imports
import { useIntl } from 'react-intl';

// constants imports
import { APP_INACTIVITY_TIMEOUT } from 'store/constant';

function useSignOutTimer(signOut, isLoggedIn) {
    const intl = useIntl();
    const [secondsLeft, setSecondsLeft] = useState(APP_INACTIVITY_TIMEOUT);

    const intervalRef = useRef(null);

    const resetTimer = () => {
        setSecondsLeft(APP_INACTIVITY_TIMEOUT);
    };

    useEffect(() => {
        const keepMeLoggedIn = Boolean(localStorage.getItem('keepMeLoggedIn'));

        if (isLoggedIn === true && keepMeLoggedIn === false && typeof signOut === 'function') {
            if (intervalRef.current == null) {
                intervalRef.current = setInterval(() => {
                    setSecondsLeft((prevSeconds) => {
                        if (prevSeconds > 0) {
                            return prevSeconds - 10000;
                        }
                        return prevSeconds;
                    });
                }, 10000);
            }

            if (secondsLeft === 60) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: intl.formatMessage({ id: 'ui-comp-snackbar-signouttimeout-minutes-left' }, { minutes: 1 }),
                        variant: 'alert',
                        alert: { color: 'warning' }
                    })
                );
            }

            if (secondsLeft === 0) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                dispatch(closeSnackbar());
                signOut();
            }
        }

        document.addEventListener('mousemove', resetTimer);
        document.addEventListener('click', resetTimer);

        return () => {
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            document.removeEventListener('mousemove', resetTimer);
            document.removeEventListener('click', resetTimer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, secondsLeft, signOut]);

    return secondsLeft;
}

export default useSignOutTimer;
